import { render } from "./FragranceMetricsTable.vue?vue&type=template&id=00a0af8d&scoped=true"
import script from "./FragranceMetricsTable.vue?vue&type=script&lang=js"
export * from "./FragranceMetricsTable.vue?vue&type=script&lang=js"

import "./FragranceMetricsTable.vue?vue&type=style&index=0&id=00a0af8d&lang=scss&scoped=true"
import "./FragranceMetricsTable.vue?vue&type=style&index=1&id=00a0af8d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a0af8d"]])

export default __exports__